import React from 'react'
import {
  TopToolbar,
  Datagrid,
  DateField,
  Filter,
  List,
  SearchInput,
  TextField,
  SelectField
} from 'react-admin'
import {status} from './choices'

const Actions = ({basePath,}) => (
  <TopToolbar>
  </TopToolbar>
)

const ListFilter = props => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn/>
  </Filter>
)

export default ({classes, ...props}) => {
  return (
    <List {...props}
          filters={<ListFilter classes={classes}/>}
          perPage={25}
          sort={{field: 'id', order: 'DESC'}}
          actions={<Actions/>}
          bulkActionButtons={false}>
      <Datagrid rowClick="show">
        <TextField source="id" />
        <SelectField source="status" choices={status} sortable={false} />
        <TextField source="name" sortable={false} />
        <TextField source="username" sortable={false} />
        <TextField source="phone" sortable={false} />
        <TextField source="email" sortable={false} />
        <DateField source="createdAt" locales='ko' showTime sortable={false} />
      </Datagrid>
    </List>
  )
}

